<script lang="ts">
    export let cities: Array<{
        slug: string;
        displayName: string;
        city: string;
        state: string;
        jobCount: number;
    }> = [];
</script>

{#if cities.length > 0}
    <section class="browse-locations">
        <h2>Browse by location</h2>
        <ul class="jobs">
            {#each cities as c}
                <li>
                    <a href="/jobs-in/{c.slug}">{c.displayName}</a>
                    <span class="tag">{c.jobCount} {c.jobCount === 1 ? 'job' : 'jobs'}</span>
                </li>
            {/each}
        </ul>
    </section>
{/if}
